<template>
    <Modal v-model="show" title="客户经理项目人部门成员信息" :width="60">
        <Spin v-if="$globalSpin" size="large" fix></Spin>
        <Form
            ref="modelForm"
            :model="modelForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form"
        >
            <Row :gutter="16">
                <Col span="24">
                    <FormItem label="选择公司" prop="projectCompany">
						<Select v-model="modelForm.projectCompany">
							<Option v-for="item in companyList" :value="item.projectCompany" :key="item.projectCompany">{{ item.projectCompany }}</Option>
						</Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择部门" prop="projectName">
						<Select v-model="modelForm.projectName">
							<Option v-for="item in deptList" :value="item.projectName" :key="item.projectName">{{ item.projectName }}</Option>
						</Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="选择成员" prop="projectCode">
						<Select v-model="userName">
							<Option v-for="item in memberList" :value="item.userPersonName" :key="item.userName">{{ item.userName }}-{{ item.userPersonName }}</Option>
						</Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem label="部门类型" prop="projectType">
                        <Select v-model="modelForm.projectType">
                            <Option value="市场部门">市场部门</Option>
                            <Option value="非市场部门">非市场部门</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button type="primary" @click="onSave">确认</Button>
            <Button type="error" @click="onCancel">取消</Button>
        </div>
    </Modal>
</template>

<script>
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";

import {
    getCustomerMgrCompanyList,
    getCustomerMgrDeptList,
    getCustomerMgrMemberList,
    saveProject
} from "@/api/modules/account-management/inspector-user-management";
import DepartmentList from "../department-management/department-list.vue";

export default {
    name: "DeptMemberCusMgrLeaderUpdate",
    data() {
        return {
            show: false,
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userName: "",
            modelForm: {
                projectCode: "",
                projectName: "",
                projectCompany: "",
                projectType: "",
                belongTo: "客户经理项目人"
            },
            ruleValidate: {
                projectCompany: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                projectName: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                projectCode: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ],
                projectType: [
                    {
                        trigger: "blur",
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                callback();
                            }
                            else {
                                callback(new Error(" "));
                            }
                        }
                    }
                ]
            },
            companyList: [],
            deptList: [],
            memberList: []
        };
    },
    mounted() {},
    methods: {
        showModal(row) {
            this.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.modelForm = row;
            this.init();
            this.show = true;
        },
        init() {
            this.getCompanyList();
            this.getCustomerMgrDeptListInit();
            this.getMemberList();
            this.$refs.modelForm.resetFields();
        },
        getCompanyList() {
            getCustomerMgrCompanyList().then(res => {
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
            });
        },
        getCustomerMgrDeptListInit() {
            if (this.modelForm.projectCompany) {
                getCustomerMgrDeptList({
                    projectCompany: this.modelForm.projectCompany
                }).then(res => {
                    if (res.code === 0) {
                        this.deptList = res.data.records;
                        console.log("", this.deptList);
                    }
                });
            }
            else {
                this.deptList = [];
            }
        },
        onCompanyChange() {
            if (this.modelForm.projectCompany) {
                getCustomerMgrDeptList({
                    projectCompany: this.modelForm.projectCompany
                }).then(res => {
                    if (res.code === 0) {
                        this.deptList = res.data.records;
                    }
                });
            }
            else {
                this.deptList = [];
            }
        },
        getMemberList() {
            let that = this;
            getCustomerMgrMemberList({ showAllData: "all" }).then(res => {
                if (res.code === 0) {
                    this.memberList = res.data.records;
                    if (res.data.records != null) {
                        let userModels = res.data.records.filter(e => {
                            return e.userName === that.modelForm.projectCode;
                        });
                        that.userName = userModels[0].userPersonName;
                    }
                }
            });
        },
        onSave() {
            this.$refs.modelForm.validate(valid => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }

                const data = Object.assign(
                    {
                        formEditMode: this.formEditMode
                    },
                    this.modelForm
                );

                this.$showGlobalSpin();
                saveProject(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped></style>
